import React, { useState } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { FormControl } from '@material-ui/core';
import { PasslyButton, ErrorBlock, ButtonSubmit, PasslyTextField } from '@app/components';
import { accountService } from '@app/services';
import { SetDataForPswResetSmsResponse, SetVerificationCode, DataForPswResetSmsResponse } from '@app/models';
import { returnToLogin } from '../helpers';

interface IProps {
    userDataForSubmitCode: DataForPswResetSmsResponse;
    setUserDataForChangePassword: SetDataForPswResetSmsResponse;
}

const handleChangeVerificationCode = (setVerificationCode: SetVerificationCode) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setVerificationCode(e.target.value);
};

export const ResetPasswordSuggestionEmailCode: React.SFC<IProps> = ({ userDataForSubmitCode, setUserDataForChangePassword }) => {
    const { translation } = useTypedTranslation();
    const [isError, setIsError] = useState<boolean>(false);
    const [verificationCode, setVerificationCode] = useState<string>('');

    const handleSubmit = (e: React.ChangeEvent<HTMLFormElement>) => {
        e.preventDefault();

        accountService.askServerResetPassword(
            Object.assign(userDataForSubmitCode, { verificationCode }),
            () => {
                setIsError(true);
            },
            (res: any) => {
                setUserDataForChangePassword(res.data);
            }
        );
    };

    return (
        <div className='reset-password'>
            <h1>{translation('RESET_SMS_CODE_HEADER')}</h1>
            <ErrorBlock className='reset-password__error' isError={isError} errorMessage={translation('RESET_VALIDATION_CODE_ERROR')} />
            <p className='reset-password__form-text'>{translation('RESET_CODE_SENT_MESSAGE')}</p>

            <form onSubmit={handleSubmit}>
                <FormControl fullWidth>
                    <PasslyTextField
                        autoFocus
                        label={'PASSWORD_RESET_CODE_PREFIX'}
                        value={verificationCode}
                        onChange={handleChangeVerificationCode(setVerificationCode)}
                        id='verification-code-input'
                        error={isError}
                        required
                        fullWidth
                    />
                </FormControl>
              <div className='reset-password__buttons'>
                <ButtonSubmit className='reset-password__button-submit' isLoad={false} buttonText={translation('RESET_SMS_VERIFY_CODE')} isDisabled={!verificationCode} disableRipple={true} />
                <PasslyButton className='reset-password__button-cancel' onClick={returnToLogin()} color='primary' disableRipple={true}>
                  {translation('CANCEL')}
                </PasslyButton>
              </div>
            </form>
        </div>
    );
};
